module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-tab-wrap"
  }, [_c('div', {
    staticClass: "menu-icon",
    on: {
      "click": _vm.menuToggle
    }
  }), _vm._v(" "), (_vm.isShow) ? _c('div', {
    staticClass: "menu-tab-mask",
    on: {
      "touchstart": function($event) {
        $event.preventDefault();
        return _vm.tabClose($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShow) ? _c('tab', {
    attrs: {
      "show": _vm.isShow
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a8c6688"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/menu-tab/index.vue
// module id = 288
// module chunks = 1 2 5 6 15 19 27 28